import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "list-header__title" }
const _hoisted_2 = {
  key: 0,
  class: "header-content bold"
}
const _hoisted_3 = {
  key: 1,
  class: "header-content bold"
}
const _hoisted_4 = { class: "list-header__subtitle" }
const _hoisted_5 = { class: "italic" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["list-header__container", { stick: _ctx.stick, highlight: _ctx.highlight }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "title", {
        title: _ctx.title,
        subtitle: _ctx.subtitle
      }, () => [
        (_ctx.size === _ctx.Size.small)
          ? (_openBlock(), _createElementBlock("h5", _hoisted_2, _toDisplayString(_ctx.capitalize(_ctx.title)), 1))
          : (_openBlock(), _createElementBlock("h4", _hoisted_3, _toDisplayString(_ctx.capitalize(_ctx.title)), 1))
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "subtitle", {
        title: _ctx.title,
        subtitle: _ctx.subtitle
      }, () => [
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.subtitle), 1)
      ])
    ]),
    _renderSlot(_ctx.$slots, "meta", {
      title: _ctx.title,
      subtitle: _ctx.subtitle
    })
  ], 2))
}